<template>
  <div class="commerce-agent-order-super-edit-panel">
    <button class="delete is-large is-pulled-right" @click="close" />
    <p class="subtitle">Super Edit Item</p>

    <p class="subtitle has-text-white has-text-weight-medium">
      {{ o.quantity }} x {{ o.item.name }}
    </p>

    <p class="subtitle has-text-white">
      Base Price {{ currency }}{{ o.item.price
      }}<span
        v-if="o.item.by_weight"
        class="has-text-grey has-text-weight-medium"
        >{{ translateByWeight(o.item.by_weight) }}</span
      >
      <span v-if="o.item.discount" class="tag is-dark is-pulled-right">
        Discount {{ o.item.discount }}
        {{ o.item.discount_type || "%" }}
      </span>
    </p>

    <div class="wrapper">
      <div class="field has-addons" style="margin-top: 10px">
        <div class="control">
          <a class="button is-medium is-light">New Price</a>
        </div>
        <div class="control is-expanded">
          <input
            class="input is-success is-medium"
            type="number"
            v-model="newPrice"
            placeholder="Price"
          />
        </div>
      </div>

      <div class="field" style="margin-top: 10px">
        <div class="control">
          <textarea
            class="textarea is-success"
            v-model="newName"
            placeholder="New Item Name"
          ></textarea>
        </div>
      </div>

      <p>
        Note: New Price only changes Base Price (discounts and options prices
        are not affected). New Name will apply to all languages.
      </p>
      <p>
        <span
          class="button is-success is-fullwidth is-medium"
          @click="updateItem"
          >Update Item</span
        >
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "CommerceAgentOrderSuperEditPanel",
  props: {
    o: Object,
    currency: String,
  },
  data() {
    return {
      newPrice: null,
      newName: null,
    };
  },
  computed: {
    //
  },
  mounted() {
    // this.newPrice = this.o.item.price;
    // this.newName = this.o.item.name; // set for all languages...
  },
  methods: {
    close() {
      this.$emit("close");
    },
    updateItem() {
      var obj = {
        newPrice: this.newPrice,
        newName: this.newName,
      };
      this.$emit("editItem", obj);
      this.close();
    },
  },
};
</script>

<style scoped>
.commerce-agent-order-super-edit-panel {
  z-index: 3;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100vw;
  padding: 10px;
  background-color: #1f1b24;
  color: white;
  padding-bottom: 30px;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  box-shadow: 0 0 4px 4px white;
}
.subtitle {
  margin-top: 5px;
  margin-bottom: 16px;
  color: #ccc;
}
.wrapper p {
  padding: 10px 0;
}
</style>